import './style.css'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import history from 'browserHistory'

import { selectors as NotesSelectors } from 'data/notes'

import PropTypes from 'prop-types'

import RoutesHelper from 'helpers/RoutesHelper'
import { selectors as UISelectors } from 'data/ui'

import providesCreateTemplateMutation from '../dataSync/providesCreateTemplateMutation'
import providesDeleteTemplateMutation from '../dataSync/providesDeleteTemplateMutation'
import fetchesAllTemplateNotes from '../dataSync/fetchesAllTemplateNotes'
import { MainPanel, MainBodyContainer } from 'components/Layout/AppLayout'

class TemplateNotesList extends React.PureComponent {
  static propTypes = {
    firstTemplateId: PropTypes.string,
    listState: PropTypes.any.isRequired,
    deleteTemplate: PropTypes.func.isRequired,
  }

  state = {
    deletingTemplateId: null,
  }

  componentDidMount() {
    this.props.fetchNextPage({ startFresh: true })
    this.redirectToFirstTemplateIfNeeded()
  }

  componentWillUnmount() {
    clearTimeout(this.redirectionOnDeleteTimeout)
  }

  componentWillUpdate(nextProps) {
    this.redirectToFirstTemplateIfNeeded(nextProps)
  }

  render() {
    return (
      <MainBodyContainer>
        <MainPanel>{this.props.children}</MainPanel>
      </MainBodyContainer>
    )
  }

  redirectToFirstTemplateIfNeeded(props = this.props) {
    if (!props.activeNoteId && props.firstTemplateId) {
      history.replace(
        RoutesHelper.templateShow({ templateId: props.firstTemplateId })
      )
    }
  }
}

const mapStateToProps = state => ({
  firstTemplateId: NotesSelectors.getAllTemplateNotes(state).map(
    template => template.id
  )[0],
  listState: NotesSelectors.getAllTemplateNotesListState(state),
  activeNoteId: UISelectors.getActiveNoteId(state),
})

export default compose(
  providesCreateTemplateMutation,
  providesDeleteTemplateMutation,
  fetchesAllTemplateNotes(),
  connect(mapStateToProps)
)(TemplateNotesList)
